export default __webpack_public_path__ + "static/media/logo.2ca0445a.png";